(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hawUtils", [], factory);
	else if(typeof exports === 'object')
		exports["hawUtils"] = factory();
	else
		root["hawUtils"] = factory();
})(window, function() {
return 